import { createContext, useContext } from 'react';

//
// Type declarations for the GeoGebra JavaScript API
//

const GGBAppletApiContext = /*#__PURE__*/createContext(undefined);
function useGGBAppletApi() {
  return useContext(GGBAppletApiContext);
}

export { GGBAppletApiContext, useGGBAppletApi };
//# sourceMappingURL=context.applet.js.map
